import { AxiosService } from '../../../../axios/axios.service';
import {
  tLeadsBulkUpdatePayload,
  tLeadsByAssignee,
  tPipesPermissionsResponse,
  tUpdateLeadsInBulkResponse,
  tUpdateWorkspaceUserGoal,
  tUpdateWorkspaceUserPipes,
  tUpdateWorkspaceUserPipesResponse,
  tUpdateWorkspaceUserRol,
} from './Team.types';

export const teamService = {
  getPipes: async function (
    workspaceId: string,
  ): Promise<tPipesPermissionsResponse> {
    try {
      const response = await AxiosService.get<{
        data: tPipesPermissionsResponse;
      }>(`/pipes/permissions?workspaceId=${workspaceId}`);
      return Promise.resolve(response.data);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  updateLeadsInBulk: async function (
    workspaceId: string,
    userAuthId: string,
    payload: tLeadsBulkUpdatePayload,
  ): Promise<void> {
    try {
      const config = {
        isLegacy: true,
        headers: {
          'Auth-id': userAuthId,
        },
      };
      await AxiosService.put<
        tLeadsBulkUpdatePayload,
        tUpdateLeadsInBulkResponse
      >(`leads/ws/${workspaceId}/lds/bulk-edit`, payload, config);
      return Promise.resolve();
    } catch (error) {
      return Promise.reject(error);
    }
  },
  getLeadsByAssignee: async function (
    workspaceId: string,
    assigneeId: string,
    page: number = 1,
  ): Promise<tLeadsByAssignee> {
    try {
      const response = await AxiosService.get<{ data: tLeadsByAssignee }>(
        `workspace/${workspaceId}/leads/chats?page=${page}&assignedUserId=${assigneeId}`,
      );
      return Promise.resolve(response.data);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  updateWorkspaceUserRol: async (
    workspaceId: string,
    userToUpdateAuthId: string,
    role: string,
  ): Promise<tUpdateWorkspaceUserRol> => {
    const payload = {
      role,
    };
    const config = {
      isLegacy: true,
      headers: {},
    };

    try {
      const response = await AxiosService.post<
        tUpdateWorkspaceUserRol,
        tUpdateWorkspaceUserRol
      >(
        `workspaces/ws/${workspaceId}/user/${userToUpdateAuthId}/update-role`,
        payload,
        config,
      );
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  updateUserWorkspaceGoal: async (
    workspaceId: string,
    userToUpdateAuthId: string,
    goal: number,
  ): Promise<tUpdateWorkspaceUserGoal> => {
    const payload = {
      goal,
    };

    const config = {
      isLegacy: true,
      headers: {},
    };

    try {
      const response = await AxiosService.post<
        tUpdateWorkspaceUserGoal,
        tUpdateWorkspaceUserGoal
      >(
        `workspaces/ws/${workspaceId}/user/${userToUpdateAuthId}/update-goal`,
        payload,
        config,
      );
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  updateWorkspaceUserFunnels: async (
    workspaceId: string,
    currentUserAuthId: string,
    userToUpdateUUID: string,
    funnelsIds: string[],
  ): Promise<tUpdateWorkspaceUserPipesResponse> => {
    const option = {
      isLegacy: true,
      headers: {
        'Auth-id': currentUserAuthId,
      },
    };
    const payload = {
      funnels: funnelsIds,
    };
    try {
      const response = await AxiosService.post<
        tUpdateWorkspaceUserPipes,
        tUpdateWorkspaceUserPipesResponse
      >(`leads/ws/${workspaceId}/usr/${userToUpdateUUID}`, payload, option);
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
};
